import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "sua loja foi verificada" (o admin acendeu o selo). O
 * subject e o proprio destinatario (User); store_name + username vem de
 * content() para montar o texto e o link /u/{username}/seller.
 */
export default class SellerVerifiedNotification extends Notification {
  icon() {
    return 'fas fa-circle-check';
  }
  href() {
    const username = this.attrs.notification.content()?.username;
    if (!username) return '#';
    return app.route('marketplace.user_seller', {
      username
    });
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.seller_verified', {
      store: data.store_name
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.store_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/SellerVerifiedNotification', SellerVerifiedNotification);